import styled from "styled-components";

export const TextTitle = styled.p`
    width: 100%;
    max-width: 508px;
    margin: 0 auto;
    color: ${({ theme }) => theme?.colors?.text?.headings};
    text-align: left;
    font-family: "Red Hat Display", sans-serif;
    font-size: 58px;
    font-style: normal;
    font-weight: 900;
    line-height: 100%; /* 64px */
    span {
        color: ${({ theme }) => theme?.colors?.theme?.brandColor3};
        font-family: "Red Hat Display", sans-serif;
        font-style: normal;
        font-weight: 900;
        line-height: 100%; /* 64px */
    }
`;

export const TextDescription = styled.p`
    max-width: 508px;
    margin: 0;
    color: ${({ theme }) => theme?.colors?.text?.headings};
    font-size: 48px;
    line-height: 100%;
    font-weight: 900;
    font-size: 20px;
    font-weight: 400;
    margin-top: 16px;
`;